import React, { useEffect, useState } from 'react';
import { getData, getImage } from '../../helpers/indexedDbHelper';
import { useRefresh } from '../../hooks/useRefresh';
import { useVideoBlob } from '../../hooks/useVideoBlob';
import LayoutContent from '../../components/layouts/content2';
import { useTranslation } from 'react-i18next';
import ListProducts from './ListProducts';
import SpecialsScreen from './specials';
import CategoriesScreen from './categories';
import EventsScreen from './events';
import DetailProduct from './DetailProduct';
import { useSelector } from 'react-redux';
import Alcoholic from './alcoholic';
import Drinks from './drinks';
import Pollo from './pollo';
import LunchSpecial from './lunchspecial';
import Food from './food';
import { getImageUrl } from '../../helpers/imageUrls';

function Index() {

    const {i18n} = useTranslation();
    const langEng = i18n.language === 'en' ?? false;
    const {change, getInitData} = useRefresh();
    const [menus, setMenus] = useState([]);
    const [dataDish, setDataDish] = useState(false);
     const [showDetailProduct, setShowDetailProduct] = useState(false);
    const [showListProduct, setShowListProduct] = useState(false);
    const [showSpecials, setShowSpecials] = useState(false);
    const [showCocktails, setShowCocktails] = useState(false);
    const [showEvents, setShowEvents] = useState(false);
    const [showCategories, setshowCategories] = useState(false);
    const [dishs, setdishs] = useState(false);
    const [desserts, setdesserts] = useState(false);
    const [showDrinks, setShowDrinks] = useState(false);
    const [showLunchSpecial, setShowLunchSpecial] = useState(false);
    const [Beverages, setBeverages] = useState(false);
    const [pastapecado, setpastapecado] = useState(false);
    const [cocinacolombiana, setcocinacolombiana] = useState(false);
    const [fuertes, setfuertes] = useState(false);
    const [polloasado, setpolloasado] = useState(false);
    const [entradas, setentradas] = useState(false);
    const [antojitos, setantojitos] = useState(false);
    const [drinks, setdrinks] = useState(false);
    const [merch, setmerch] = useState(false);
    
     const [showFood, setShowFood] = useState(false);
        const [showPollo, setshowPollo] = useState(false);
    const [showReviews, setShowReviews] = useState(false);
    const [showLocations, setShowLocations] = useState(false);

    // Videos servidos desde IndexedDB (blob:) para que sigan corriendo sin internet.
    const bannerVideo = useVideoBlob(require('./assets/banner1.mp4'));
    const bannerBottomVideo = useVideoBlob(require('./assets/bannerh2.mp4'));
    
   

    const fetchImage = async (id) => {
        // Una sola object URL por imagen, compartida y con tope LRU (helpers/imageUrls).
        return getImageUrl(id);
    };




         const {
           goHomeInit
         } = useSelector((state) => state.initLoad);
        
    
        
    

    useEffect(() => {
        getData('menu').then((items) => {
            const data = items.value.data;
           
            setMenus(data);
        });
    }, [change]);

    useEffect(() => {
        menus.map((item) => {
            if (item.id === 985) {
                setdesserts(item);
            }
            if (item.id === 628) {
                setBeverages(item);
            }

            if (item.id === 990) {
                setpastapecado(item)
            }
             if (item.id === 986) {
                setcocinacolombiana(item)
             }
            
            if (item.id === 909) {
                setfuertes(item)
            }
            if (item.id === 910) {
                setpolloasado(item)
            }

            if (item.id === 908) {
                setentradas(item)
            }
            if (item.id === 913) {
                setantojitos(item)
            }

            if (item.id === 915) {
                setdrinks(item)
            }
            if (item.id === 1032) {
                setmerch(item)
            }

            

            
        });
    }, [menus]);


    const GoBeverages = () => {
        setShowListProduct(true);
        setdishs(Beverages);
    }


    
    useEffect(() => {
        const handleVisibilityChange = () => {
        if (document.visibilityState === "hidden") {
            console.log("La página ha perdido el foco (está oculta).");
            setShowListProduct(false);
            setShowSpecials(false)
          
          
           setShowLunchSpecial(false)
          
            setshowCategories(false)
            setShowDetailProduct(false)
            setShowCocktails(false)
            setShowEvents(false)
            setShowDrinks(false)

            getInitData()
        } else if (document.visibilityState === "visible") {
            console.log("La página está en foco (visible).");
        }
        };

        document.addEventListener("visibilitychange", handleVisibilityChange);

        // Limpieza del evento al desmontar el componente
        return () => {
        document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, []);


      useEffect(() => {
     
                setShowListProduct(false);
            setShowSpecials(false)
          
           
           setShowLunchSpecial(false)
          
            setshowCategories(false)
          setShowDetailProduct(false)
           setShowCocktails(false)
            setShowEvents(false)
            setShowDrinks(false)
         }, [goHomeInit]);

    // El manejo de errores globales vive en helpers/kiosk.js (installGlobalErrorReload):
    // acá se reasignaba window.onerror en cada render y recargaba sin ningún tope.

    return (
          <div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 9999}}>
            <LayoutContent goCategories={() => {
                setShowDrinks(true)
            }} showBack={false} showCocktails={GoBeverages} showEvents={setShowEvents} showImageTop={true} setShowSpecials={() => {
             setShowListProduct(true);
            setdishs(merch);
        }}>
                <div>
                    

                    <div style={{ width: '100%',position: 'relative', zIndex: 900, marginTop: 20, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        
                        <img
                             onContextMenu={(e) => e.preventDefault()}
                        style={{
                            width: 210,
                            height: 80,
                            justifyContent: 'center',
                            objectFit: 'contain',
                             pointerEvents: 'none',
                            zIndex: 100,
                            alignSelf: 'center',
                            marginTop: -20,
                            marginBottom: 10,
                            marginLeft: -30
                        }}
                        src={require('./assets/logo.png')}
                        />

                        
                       
                    </div>

             
                    
                    <div style={{
                     display: 'flex', width: '100%',
                        position: 'relative', zIndex: 100, paddingInline: 40,
                        boxSizing: 'border-box',
                        gap: 30,
                        marginTop: 70
                       
                    }}>
                       
                        
                    <div style={{ width: '45%',}}>
                            {bannerVideo && <video
                            key={bannerVideo}
                            src={bannerVideo}
                            loop autoPlay={true} muted playsInline preload="auto"
                            style={{
                               
                                width: '100%',
                                height:444  ,
                                objectFit: 'cover',
                                borderRadius: 14,
                                alignSelf: 'self-start',

                            }}
                            />}


                    </div>

                    <div style={{ width: '55%',  }} >
                          
                        <div
                            style={{
                                display: 'grid',
                                height: 450,
                                overflowY: 'auto',
                                paddingRight: 0,
                                boxSizing: 'border-box',
                               
                            }}
                            >
                                 <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    width: '100%',
                                   height: 105,
                                    marginBottom: 5,
                                    position: 'relative',
                                        cursor: 'pointer',
                                    backgroundImage: `url(${require(langEng ? './assets/categorias/en/1.png' : './assets/categorias/1.png')})`,
                                    backgroundPosition: 'center',
                                    backgroundSize: '100% 100%',
                                        backgroundRepeat: 'no-repeat',
                                    borderRadius: 15,
                                    opacity: 1,
                                }}
                                onClick={() => {
                                   setShowListProduct(true);
                                     setdishs(pastapecado);
                                  //  console.log({pastapecado})
                                }}
                            >
                              
                                </div>
                                
                                  <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    width: '100%',
                                    height: 105,
                                     marginBottom: 5,
                                    position: 'relative',
                                        cursor: 'pointer',
                                    backgroundImage: `url(${require(langEng ? './assets/categorias/en/2.png' : './assets/categorias/2.png')})`,
                                    backgroundPosition: 'center',
                                    backgroundSize: '100% 100%',
                                    backgroundRepeat: 'no-repeat',
                                        opacity: 1,
                                    borderRadius: 15,
                                }}
                                onClick={() => {
                                  setShowDrinks(true)
                                }}
                            >
                                
                                </div>

                                <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    width: '100%',
                                    height: 105,
                                     marginBottom: 5,
                                    position: 'relative',
                                        cursor: 'pointer',
                                    backgroundImage: `url(${require(langEng ? './assets/categorias/en/3.png' : './assets/categorias/3.png')})`,
                                    backgroundPosition: 'center',
                                    backgroundSize: '100% 100%',
                                        backgroundRepeat: 'no-repeat',
                                    borderRadius: 15,
                                    opacity: 1,
                                }}
                                onClick={() => {
                                 setShowFood(true)
                                }}
                            >
                                
                                </div>

                                <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    width: '100%',
                                     height: 105,
                                     marginBottom: 5,
                                    position: 'relative',
                                        cursor: 'pointer',
                                    backgroundImage: `url(${require(langEng ? './assets/categorias/en/4.png' : './assets/categorias/4.png')})`,
                                    backgroundPosition: 'center',
                                    backgroundSize: '100% 100%',
                                        backgroundRepeat: 'no-repeat',
                                    borderRadius: 15,
                                    opacity: 1,
                                }}
                                onClick={() => {
                                    setShowListProduct(true)
                                    setdishs(merch)
                                }}
                            >
                                
                                </div>
                           
                              

                                
                                
                                
                                
                        </div>
                    </div>

                    
                    </div>
                            <div
                    onClick={() => {
                       // setShowListProduct(true)
                        //setdishs(desserts)
                        //  setShowDetailProduct(true)
                 //   setDataDish({ dish: tomahawk, alldish: steak, currentDish: tomahawk })
               }}
                style={{
                    width: '100%',
                    alignItems: 'center',
                
                    boxSizing: 'border-box',
                    paddingInline: 25
                   
                    }}>
                    {bannerBottomVideo && <video
                        key={bannerBottomVideo}
                        loop autoPlay={true} muted playsInline preload="auto"
                        onContextMenu={(e) => e.preventDefault()}
                        src={bannerBottomVideo}
                            style={{
                        marginTop: 10,
                        width: '95%',
                        height: 170,
                        objectFit: 'cover',
                        borderRadius: 15,
                                pointerEvents: 'none',
                         borderRadius: 15,

                    }}
                    />}

            </div>
               
            </div>

           

            {showListProduct && <ListProducts
                dishs={dishs}
                setShowListProduct={setShowListProduct}
            />}
            
            {showCategories && <CategoriesScreen setshowCategories={setshowCategories} />}
                {showSpecials && <SpecialsScreen setShowListProduct={setShowSpecials} />}

                {showLunchSpecial && <LunchSpecial setShowHappy={setShowLunchSpecial} />}

                   {showFood && <Food setShowHappy={setShowFood} />}  
                
                {showCocktails && <Alcoholic setShowHappy={setShowCocktails} />}
                {showEvents && <EventsScreen setShowHappy={setShowEvents} />}  
                {showDrinks && <Drinks setShowHappy={setShowDrinks} />}  
                {showPollo && <Pollo setShowHappy={setshowPollo} />}  
                 {showDetailProduct && <DetailProduct
                    dishMenu={dataDish}
                    setShowListProduct2={()=>setShowDetailProduct(false)}
                    setShowDetailProduct={setShowDetailProduct}
                />}
                

            </LayoutContent>

            
            <div style={{
                position: 'absolute', top: 0, left: 45,
                cursor: 'pointer', zIndex: 100, backgroundColor: '#61662f',
                width: 670,height: 150,
                borderEndEndRadius: 20,
                borderEndStartRadius: 20,
            }}></div>

            {/* <div onClick={() => setShowReviews(true)} style={{ position: 'absolute', top: 45, left: 60, cursor: 'pointer', zIndex: 1000}}>
                <img
                style={{width: 80, height: 50, objectFit: 'cover', borderRadius: 10}}
                src={require('./assets/BOTONREVIEWS.png')} />
            </div> */}

            
            <div onClick={() => setShowLocations(true)} style={{ position: 'absolute', top: 15, left: 80, cursor: 'pointer', zIndex: 1000}}>
                <img
                style={{width: 120, height: 120, objectFit: 'contain'}}
                src={require('./assets/LOCATIONS.png')} />
            </div>


            {showReviews &&
                <div
                    onClick={() => setShowReviews(false)}
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        backgroundColor: 'rgba(0,0,0,0.8)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 99999,
                    }}>
                    <img
                        onClick={(e) => e.stopPropagation()}
                        src={require('./assets/qrreviews.png')}
                        style={{
                            width: '70%',
                            maxWidth: 700,
                            maxHeight: '85vh',
                            objectFit: 'contain',
                        }} />
                </div>
            }

            {showLocations &&
                <div
                    onClick={() => setShowLocations(false)}
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        backgroundColor: 'rgba(0,0,0,0.8)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 99999,
                    }}>
                    <img
                        onClick={(e) => e.stopPropagation()}
                        src={require('./assets/locationsimage.jpg')}
                        style={{
                            width: '70%',
                            maxWidth: 700,
                            maxHeight: '85vh',
                            objectFit: 'contain',
                        }} />
                </div>
            }
            </div>
    );
}

export default Index;